import { render, staticRenderFns } from "./BonusPanel.vue?vue&type=template&id=42a846d6&"
import script from "./BonusPanel.vue?vue&type=script&lang=js&"
export * from "./BonusPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports